export default {
  "content": "<path d=\"M4.99 11.656l1.25-1.229 2.874 2.876v-9.96h1.75v9.96l2.875-2.876 1.25 1.23-5 5-5-5z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};